document.addEventListener('alpine:init', () => {
  Alpine.data('RadioBar', (streamUrl, metaUrl) => ({
    nowPlaying: '',
    playing: false,
    ready: false,
    _metaTimer: null,
    _audio: null,
    _fadeRaf: null,
    _onMp3Play: null,

    init() {
      if (!streamUrl) return;

      this._audio = new Audio(streamUrl);
      this._audio.preload = 'none';

      this._audio.addEventListener('play', () => {
        this.playing = true;
      });
      this._audio.addEventListener('pause', () => {
        this.playing = false;
      });
      this._audio.addEventListener('error', (e) => {
        this.playing = false;
        window.debugLog('[RadioBar] audio error', e);
      });

      this._onMp3Play = () => this.fadeOutAndPause();
      window.addEventListener('sv:mp3-play', this._onMp3Play);

      this.ready = true;
      this.fetchMeta();
      this._metaTimer = setInterval(() => this.fetchMeta(), 15000);
    },

    destroy() {
      if (this._metaTimer) clearInterval(this._metaTimer);
      if (this._fadeRaf) cancelAnimationFrame(this._fadeRaf);
      if (this._onMp3Play) window.removeEventListener('sv:mp3-play', this._onMp3Play);
      if (this._audio) {
        this._audio.pause();
        this._audio.src = '';
      }
    },

    fadeVolume(from, to, duration = 300) {
      return new Promise((resolve) => {
        if (!this._audio) {
          resolve();
          return;
        }

        if (this._fadeRaf) cancelAnimationFrame(this._fadeRaf);

        const start = performance.now();
        const step = (now) => {
          const t = Math.min(1, (now - start) / duration);
          this._audio.volume = from + (to - from) * t;
          if (t < 1) {
            this._fadeRaf = requestAnimationFrame(step);
          } else {
            this._fadeRaf = null;
            resolve();
          }
        };
        this._fadeRaf = requestAnimationFrame(step);
      });
    },

    async fadeOutAndPause() {
      if (!this._audio || this._audio.paused) return;
      await this.fadeVolume(this._audio.volume, 0);
      this._audio.pause();
      this._audio.volume = 1;
    },

    async toggle() {
      if (!this.ready || !this._audio) return;

      if (this.playing || !this._audio.paused) {
        await this.fadeOutAndPause();
        return;
      }

      window.dispatchEvent(new CustomEvent('sv:radio-play'));
      this._audio.volume = 0;
      try {
        await this._audio.play();
        await this.fadeVolume(0, 1);
      } catch (e) {
        window.debugLog('[RadioBar] play blocked', e);
      }
    },

    async fetchMeta() {
      if (!metaUrl) return;

      try {
        const res = await fetch(metaUrl);
        if (!res.ok) return;
        const data = await res.json();
        this.nowPlaying = data?.[0]?.title || '';
      } catch (e) {
        window.debugLog('[RadioBar]', e);
      }
    },
  }));
});
